import request from '@/utils/request'
import { AxiosResult, AxiosPagination } from '@/typings/common'

/**
 * ************************************** 销售业绩辅导 **************************************
 */
//  获取销售业绩辅导列表数据
export function salesSkillsCoachingList(data?: any) {
  return request.post<AxiosPagination<any>>('/lbu/api/salesSkillsCoaching/page', data)
}

export function salesSkillsCoachingCreate(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/salesSkillsCoaching/create', data)
}

export function salesSkillsCoachingUpdate(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/salesSkillsCoaching/update', data)
}

export function salesSkillsCoachingReview(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/salesSkillsCoaching/review', data)
}

export function salesSkillsCoachingCommentCreate(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/salesSkillsCoaching/comment/create', data)
}

export function salesSkillsCoachingCommentDelete(data: {id?: string}) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/salesSkillsCoaching/comment/delete', data)
}

export function salesSkillsCoachingConfirm(data: {id?: string}) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/salesSkillsCoaching/confirm', data)
}

export function salesSkillsCoachingDelete(data: {id?: string}) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/salesSkillsCoaching/delete', data)
}

export function salesSkillsCoachingDetail(data: {id?: string}) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/salesSkillsCoaching/detail', data)
}
